import {getAccessToken} from '@/helpers/auth';
import wretch, {ResponseChain, Wretcher} from 'wretch';
import config from '@/config';

export default class ApiHelpers {
  static getBearer(): Promise<string> {
    return getAccessToken();
  }

  static doAuthRequest(path: string): Promise<Wretcher> {
    return ApiHelpers.getBearer().then(token => wretch().url(`${config.api.endpoint}${path}`).auth(`Bearer ${token}`));
  }

  static get<T>(path: string): Promise<T> {
    return ApiHelpers.doAuthRequest(path).then(request => request.get().json());
  }

  static getRaw<T>(path: string): Promise<ResponseChain> {
    return ApiHelpers.doAuthRequest(path).then(request => request.get());
  }

  static post<T>(path: string, data: unknown): Promise<T> {
    return ApiHelpers.doAuthRequest(path).then(request => request.post(data).json());
  }

  static patch<T>(path: string, data: unknown): Promise<T> {
    return ApiHelpers.doAuthRequest(path).then(request => request.patch(data).json());
  }

  static delete(path: string): Promise<any> {
    return ApiHelpers.doAuthRequest(path).then(request => request.delete().json());
  }
}
